module.exports = __webpack_public_path__ + "img/fr_fr.ebcb4218.png";